import { createI18n } from "vue-i18n";
import DOMPurify from "dompurify";
import { Locale } from "vant";

import { locale as en } from "@/config/i18n/en";
import { locale as zh } from "@/config/i18n/ch";

// 引入 Element Plus 语言包
import zhEle from "element-plus/es/locale/lang/zh-cn";
import enEle from "element-plus/es/locale/lang/en";

// 引入 Vant 语言包
import vantEnUS from "vant/es/locale/lang/en-US";
import vantZhCN from "vant/es/locale/lang/zh-CN";

let messages = {};
messages = {
  ...messages,
  en: { ...en, ...enEle, ...vantEnUS },
  zh: { ...zh, ...zhEle, ...vantZhCN },
};

// get current selected language
let lang =
  (
    localStorage.getItem("language") ||
    navigator.language ||
    navigator.browserLanguage
  )
    .toLowerCase()
    .indexOf("zh") != -1
    ? "zh"
    : "en";

//判断来源是否是CRM
let params = new URLSearchParams(location.search);
let token = params.get("token");
if (token || params.get("sourceType")) {
  if (token) {
    if (params.get("sourceType") === "CRM" || params.get("sourceType") === "OBT") {
      if (params.get("lang")) {
        lang = params.get("lang") === "zh-CN" ? "zh" : "en";
      }
    }
  } else {
    lang = localStorage.getItem("language");
  }
}

const sanitizeTranslatedHtml = (translation) => {
  // Keep non-string translations (arrays/objects) unchanged for option lists.
  if (typeof translation !== "string") {
    return translation;
  }
  return DOMPurify.sanitize(translation, {
    ALLOWED_TAGS: ["a", "br", "span"],
    ALLOWED_ATTR: ["class", "href", "rel", "target"],
  });
};

// Create VueI18n instance with options
const i18n = createI18n({
  legacy: true,
  locale: lang,
  messages,
  escapeParameterHtml: true,
  postTranslation: sanitizeTranslatedHtml,
});

// 更新 Element Plus 的语言
// 注意：Element Plus 会自动使用 VueI18n 的当前语言，这里不需要额外配置

// 更新 Vant 组件库本身的语言变化，支持国际化
Locale.use(lang, messages[lang]);

export default i18n;